"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserServiceContract = exports.UserServiceContractTermsTypes = void 0;
var lodash_1 = require("lodash");
var helpers_1 = require("../../helpers");
var package_1 = require("../../package");
var package_2 = require("../../package");
var user_service_1 = require("./user-service");
var user_service_contract_order_1 = require("./user-service-contract-order");
var user_service_contractor_1 = require("./user-service-contractor");
exports.UserServiceContractTermsTypes = [package_1.ServiceContractTerms20221225.Package, package_1.ServiceContractTerms20230418.Package];
var properties = ['id', 'user_service_id', 'school_id', 'teacher_ids', 'user_service_terms', 'user_service', 'status', 'visit_info', 'contractors', 'begin_at', 'end_at', 'created_at', 'updated_at', 'deleted_at', 'can', 'is', 'purl'];
var dateProperties = ['begin_at', 'end_at', 'created_at', 'updated_at', 'deleted_at'];
/** Контракт на оказание услуги = условия, на которых ученик записался на одно или несколько занятий к преподавателю */
var UserServiceContract = /** @class */function () {
  function UserServiceContract(values) {
    values.user_service_terms = package_2.PackageBuilder.createInstance(values.user_service_terms);
    values.user_service = new user_service_1.UserService(values.user_service);
    if (values.visit_info) {
      if (values.visit_info.contractor) {
        values.visit_info.contractor = new user_service_contractor_1.UserServiceContractor(values.visit_info.contractor);
      }
      if (values.visit_info.unpaid_order) {
        values.visit_info.unpaid_order = new user_service_contract_order_1.UserServiceContractOrder(values.visit_info.unpaid_order);
      }
    }
    values.contractors = (values.contractors || []).map(function (c) {
      return new user_service_contractor_1.UserServiceContractor(c);
    });
    (0, lodash_1.assign)(this, (0, lodash_1.pick)(values, properties));
    (0, helpers_1.assignDates)(this, values, dateProperties);
  }
  /**
   * Преобразует к типу UserService
   *
   * @deprecated
   * @see UserServiceContract.user_service
   */
  UserServiceContract.castToUserService = function (contract) {
    if (!contract) {
      return null;
    }
    var terms = package_2.PackageBuilder.createInstance(contract.user_service_terms);
    var _package = terms.package;
    switch (_package) {
      case package_1.PackageEnum.ServiceContractTerms20221225Package:
        {
          return new user_service_1.UserService(__assign(__assign({}, contract.user_service_terms), {
            id: contract.user_service_id,
            author_id: contract.teacher_ids[0],
            readonly: true,
            hidden: true
          }));
        }
      case package_1.PackageEnum.ServiceContractTerms20230418Package:
        {
          return new user_service_1.UserService(__assign(__assign({}, contract.user_service_terms), {
            id: contract.user_service_id,
            author_id: contract.teacher_ids[0],
            readonly: true,
            hidden: true
          }));
        }
      default:
        {
          var __package = _package ? package_1.PackageEnum[_package] || String(_package) : '<null>';
          throw new Error("package=".concat(__package, " not supported"));
        }
    }
  };
  return UserServiceContract;
}();
exports.UserServiceContract = UserServiceContract;
